<template>
  <article id="article-fund-overview" v-if="detail">
    <modal-slide-up v-if="isModal" @close-modal="closeModal">
      <h3 slot="header"></h3>
      <div slot="body">
        <div id="fund-dividend" v-if="arrDividend && arrDividend.length > 0">
          <h2>ประวัติการปันผล (Dividend History)</h2>
          <div class="dividend-table">
            <div class="dividend-head">
              <div class="dividend-row">
                <div class="dividend-col">วันที่ปิดสมุดทะเบียน</div>
                <div class="dividend-col">วันที่ปันผล</div>
                <div class="dividend-col">จำนวนเงิน (บาท)</div>
              </div>
            </div>
            <div class="dividend-body">
              <div class="dividend-row" v-for="(item, index) in arrDividend" :key="index">
                <div class="dividend-col">{{ changeFormatDate(item.xd_date) }}</div>
                <div class="dividend-col">{{ changeFormatDate(item.pay_date) }}</div>
                <div class="dividend-col">{{ item.dividend }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal-slide-up>

    <section id="section-fund-intro">
      <div class="intro-header">
        <div class="intro-header-name">
          <h1>{{ detail.short_code }}</h1>
          <p>{{ detail.name_th }}</p>
        </div>
        <div class="intro-subscriber">
          <flex-card
            v-if="templateShare && hasShare"
            :templateFlex="templateShare.template"
            :isPrepareCompleted="templateShare && templateShare.template ? isPrepareCompleted : false"
            @reset-fact="resetFact"
            class="share-assets"
          >
            <a slot="button" :data-action="'share_fund'" @click="generateShareTemplate">
              <i class="fas fa-share-alt"></i>
            </a>
          </flex-card>

          <download-assets
            v-if="false && this.detail && this.detail.short_code"
            class="download-assets"
            :dataType="`fund`"
            :name="this.detail.short_code"
          />

          <a href="javascript:;" class="subscribe-btn">
            <i class="fas fa-spinner-third fa-spin" v-if="loadingWatchlist"></i>
            <i
              v-else
              data-action="follow_fund_update"
              :class="[isFollowing ? 'fas fa-star following' : 'fas fa-star']"
              @click="addWatchlist('FundQuote')"
            ></i>
          </a>
        </div>
      </div>
      <div v-if="navLatest" class="intro-nav">
        <h2 class="fund-nav">{{ navLatest.value }}</h2>
        <span>฿</span>
        <p class="date-nav">
          <i class="far fa-clock"></i>
          {{ changeFormatDate(navLatest.nav_date) }}
        </p>
      </div>
    </section>

    <section id="section-graph">
      <graph-nav v-if="id" :id="id" @call-tradingview="chartModal(detail.short_code)" />
    </section>

    <section v-if="false" id="section-invest-now">
      <div class="invest-now__container" @click="investNow">
          <IconButton class="invest-now__container--icon" :name="'fas fa-cart-plus'"/>
          <div class="invest-now__container--text">ซื้อกองทุนนี้</div>
      </div>

      <InvestNow :isLoading.sync="isLoading" :isSending.sync="isSending" :noFriendship.sync="noFriendship" />
    </section>

    <section id="section-perf-overview">
      <h2>Return</h2>
      <div class="perf-box">
        <div class="perf-item">
          <h4
            :class="[detail.total_return_3m >= 0 ? 'plus': 'minus']"
          >{{ detail.total_return_3m ? parseFloat(detail.total_return_3m).toFixed(2) : ''}}%</h4>
          <p>3M</p>
        </div>
        <div class="perf-item">
          <h4
            :class="[detail.total_return_6m >= 0 ? 'plus': 'minus']"
          >{{ detail.total_return_6m ? parseFloat(detail.total_return_6m).toFixed(2) : ''}}%</h4>
          <p>6M</p>
        </div>
        <div class="perf-item">
          <h4
            :class="[detail.total_return_1y >= 0 ? 'plus': 'minus']"
          >{{ detail.total_return_1y ? parseFloat(detail.total_return_1y).toFixed(2) : ''}}%</h4>
          <p>1Y</p>
        </div>
        <div class="perf-item view-all-perf">
          <a data-action="open_all_performance" href="javascript:;" @click="viewPerfAll()">
            ดูทั้งหมด
            <i class="fas fa-angle-right"></i>
          </a>
        </div>
      </div>
    </section>

    <section id="section-dividend" v-if="arrDividend && arrDividend.length > 0">
      <h2>Latest Dividend Paid</h2>
      <div class="dividend-box">
        <div class="dividend-detail">
          <div class="detail-row">
            <div class="detail-col">
              <h4>วันที่ปันผล</h4>
              <p>{{ changeFormatDate(arrDividend[0].pay_date) }}</p>
            </div>
            <div class="detail-col">
              <h4>จำนวนเงิน (บาท)</h4>
              <p>{{ arrDividend[0].dividend }}</p>
            </div>
          </div>
          <div class="line-seperate"></div>
        </div>
        <div class="dividend-ctn">
          <a href="javascript:;" data-action="open_all_dividend" @click="callModal">
            ประวัติปันผล
            <i class="fas fa-angle-right"></i>
          </a>
        </div>
      </div>
    </section>

    <section id="section-3d-diagram">
      <h2>FINNOMENA 3D Diagram</h2>

      <div class="d3-radar">
        <div class="d3-radar-left">
          <p>Past Performance</p>
          <a
            v-if="arrD3"
            class="value-pill"
            :class="D3Class(arrD3.pp.text)"
            href="javascript:;"
          >{{D3Text(arrD3.pp.text)}}</a>
        </div>
        <div class="d3-radar-center">
          <p>เส้นประ คือ ค่าเฉลี่ย</p>
          <div class="line-dashed"></div>
          <div class="d3-diagram">
            <d3-radar-chart :fundID="id" :data="arrD3" />
          </div>
          <p>Maximum Drawdown</p>
          <a
            v-if="arrD3"
            class="value-pill"
            :class="D3Class(arrD3.dd.text)"
            href="javascript:;"
          >{{D3Text(arrD3.dd.text)}}</a>
        </div>
        <div class="d3-radar-right">
          <p>Risk Adjusted Return</p>
          <a
            v-if="arrD3"
            class="value-pill"
            :class="D3Class(arrD3.rr.text)"
            href="javascript:;"
          >{{D3Text(arrD3.rr.text)}}</a>
        </div>
      </div>
    </section>

    <section id="section-fund-detail">
      <h2>Fund Details</h2>
      <div class="fund-detail">
        <div class="detail-list">
          <div class="col-head">หนังสือชี้ชวน</div>
          <div class="col-value">
            <a
              data-action="open_fund_factsheet"
              v-if="detail.fund_fact_sheet && detail.fund_fact_sheet.length > 0"
              class="fund-fact-sheet"
              target="_blank"
              v-on:click="openFundFactSheet(detail.fund_fact_sheet)"
            >หนังสือชี้ชวน</a>
            <a
              data-action="open_fund_factsheet"
              v-else-if="detail.aimc_fund_id"
              class="fund-fact-sheet"
              target="_blank"
              :href="urlAMC(detail.aimc_fund_id)"
            >หนังสือชี้ชวน</a>
            <a
              data-action="open_fund_factsheet"
              v-else
              class="fund-fact-sheet"
              target="_blank"
              :href="urlGoogle(detail.short_code)"
            >หนังสือชี้ชวน</a>
          </div>
        </div>
        <div class="detail-list">
          <div class="col-head">บลจ.</div>
          <div class="col-value">{{ detail.amc_name_en ? detail.amc_name_en : '-' }}</div>
        </div>
        <div class="detail-list">
          <div class="col-head">ประเภทกอง</div>
          <div class="col-value">{{ detail.aimc_category ? detail.aimc_category : '-' }}</div>
        </div>
        <div class="detail-list">
          <div class="col-head">ค่าความเสี่ยง</div>
          <div class="col-value">{{ detail.risk_spectrum ? detail.risk_spectrum : '-' }}</div>
        </div>
        <div class="detail-list">
          <div class="col-head">Feeder Fund</div>
          <div class="col-value">
            <a
              v-if="detail.main_feeder_fund"
              target="_blank"
              :href="generateFeederFund(detail.feeder_fund_link, detail.main_feeder_fund)"
              class="feeder-fund"
            >{{detail.main_feeder_fund !== null ? detail.main_feeder_fund: '-'}}</a>
            <span v-else>-</span>
          </div>
        </div>
        <div class="detail-list">
          <div class="col-head">นโยบายค่าเงิน</div>
          <div
            class="col-value"
          >{{ detail.exchange_rate_risk_spectrum ? detail.exchange_rate_risk_spectrum : '-' }}</div>
        </div>
        <div class="detail-list">
          <div class="col-head">นโยบายการจ่ายปันผล</div>
          <div class="col-value">{{ detail.dividend_policy ? detail.dividend_policy : '-' }}</div>
        </div>
        <div class="detail-list">
          <div class="col-head">ค่าใช้จ่ายกองทุนรวม</div>
          <div class="col-value">{{ netFee }}</div>
        </div>
        <div class="detail-list">
          <div class="col-head">วันที่จดทะเบียนกองทุน</div>
          <div class="col-value">{{ detail.inception_date | dateFilter}}</div>
        </div>
        <div class="detail-list">
          <div class="col-head">มูลค่าทรัพย์สินสุทธิ</div>
          <div
            class="col-value"
          >{{ detail.net_assets !== null ? parseNumberFormat(detail.net_assets) + ' บาท': '-'}}</div>
        </div>
      </div>
    </section>

    <section id="section-related-article" v-if="arrArticle && arrArticle.length > 0">
      <h2>Related Article</h2>
      <div
        v-for="(item, index) in arrArticle"
        :key="index"
        class="post-card"
        data-action="open_fund_articles"
        @click="open(item.link+'?webview=line&bt_id=71')"
      >
        <div class="image">
          <img class="thumbnail" :src="item.post_thumbnail_url" :alt="item.title.rendered" />
        </div>
        <div class="content">
          <div class="description">
            <div class="block-ellipsis">{{ item.title.rendered }}</div>
          </div>
        </div>
      </div>
    </section>
    <toast
      v-if="toggleToast"
      :toggleToast="toggleToast"
      :status="toastStatus"
      :toastType="toastType"
      :options="options"
      @close-toast="closeToast"
    ></toast>
  </article>
</template>
<script>
import ModalSlideUp from "../../../components/miniapp/global/ModalSlideUp.vue";
import GraphNav from "../../../components/miniapp/global/GraphNav.vue";
import FlexCard from "../../../components/miniapp/share/FlexCard.vue";
import D3RadarChart from "../../../components/miniapp/global/D3RadarChart.vue";
import * as dataLayer from "../../../utils/data-layer";
import Toast from "../../../components/miniapp/global/Toast.vue";
import DownloadAssets from "../../../components/miniapp/chatbot/DownloadAssets.vue";
import QuoteTemplate from "../../../../public/config/share/fund-quote-template.json";
import { mapGetters, mapActions } from "vuex";
import CarryActionAfterLogin from "../../../components/mixins/carry-action-after-login";
import { IconButton } from "../../../components/atoms";
import InvestNow from "../../../components/miniapp/chatbot/InvestNow.vue"
export default {
  components: {
    DownloadAssets,
    ModalSlideUp,
    GraphNav,
    D3RadarChart,
    Toast,
    FlexCard,
    IconButton,
    InvestNow
  },
  mixins: [CarryActionAfterLogin],
  data() {
    return {
      ott: "",
      options: {
        dialog: {
          title: "เลิกติดตาม",
          body: "ต้องการเลิกติดตาม",
          action: [
            {
              action1: "ใช่",
              action: "ไม่ใช่"
            }
          ]
        },
        toast: {
          duration: 2
        }
      },
      isModal: false,
      arrDividend: null,
      netFee: null,
      backEndFee: null,
      managementFee: null,
      allFee: null,
      arrD3: null,
      showChartModal: false,
      navLatest: null,
      arrArticle: null,
      destroyChart: false,
      loadingWatchlist: false,
      toggleToast: false,
      toastType: null,
      templateShare: {
        template: null
      },
      isPrepareCompleted: false,
      noFriendship: false,
      isLoading: false,
      isSending: false,
      toastStatus: false,
      isFollowing: false,
    };
  },
  watch: {
    async id(id) {
      await this.queryData(id);
    },
  },
  filters: {
    dateFilter: function(value) {
      var options = {
        year: "2-digit",
        month: "short",
        day: "numeric"
      };

      if (value) {
        return new Date(value).toLocaleDateString("th-TH", options);
      }

      return "";
    }
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: null
    }
  },
  async created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapGetters("watchlist", ["getFundWatchlist"]),
    ...mapGetters("fund", [
      "getFundCurrentPeriod",
      "getFundCurrentUnitType",
      "getFundNav"
    ]),
    ...mapGetters("auth", ["getIslogin"]),
    hasShare() {
      return process.env.VUE_APP_CONFIG_SHARE_LINK === "true";
    },
  },
  async mounted() {
    if (this.id) {
      await this.queryData(this.id);
    }
  },
  async activated() {
    if (this.getIslogin) {
      this.isFollowing = await this.checkAssetInWatchlist({
        subjectType: 'fund', 
        id: this.detail.id
      })
    }
  },
  deactivated() {
    this.isFollowing = false
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions("fund", [
      "findFundDividend",
      "findFund3D",
      "findFundNavLatest",
      "findFundFee",
      "sendFundCard",
      "findFundNav",
      "findFundNavForShare",
      "sendFundInvestImage"
    ]),
    ...mapActions("article", ["findTagsByTagName", "findArticleByParams"]),
    ...mapActions("watchlist", ["checkAssetInWatchlist", "updateWatchlist"]),
    ...mapActions("global", ["findFriendship"]),
    redirectToAuth() {
      let return_url = `${this.$route.fullPath}`
      window.location.replace(`/login?return_url=${encodeURIComponent(return_url)}`)
    },
    convertDate(date) {
      let options = {
        year: "2-digit",
        month: "short",
        day: "numeric"
      };

      if (date) {
        return new Date(date).toLocaleDateString("th-TH", options);
      }

      return "";
    },
    resetFact() {
      this.isPrepareCompleted = false;
    },
    comma: function(value) {
      if (!value && value != 0) {
        return "-";
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    numberToFixed(num) {
      return num ? parseFloat(num).toFixed(2) : 0;
    },
    calculatePerfPercent(data) {
      let firstObj = data[0];
      let lastObj = data[data.length - 1];

      let firstVal = parseFloat(firstObj.value);
      let lastVal = parseFloat(lastObj.value);

      let diffVal = lastVal - firstVal;
      let diffValPercent = (diffVal / firstVal) * 100;
      let diffValToFixed = diffValPercent.toFixed(2);

      if (diffValToFixed) {
        return diffValToFixed;
      }

      return 0;
    },
    calculatePerfValue(data) {
      if (data && data.length > 0) {
        let firstObj = data[0];
        let lastObj = data[data.length - 1];
        let diffVal = parseFloat(lastObj.value) - parseFloat(firstObj.value);
        let diffValToFixed = diffVal.toFixed(4);

        let parts = diffValToFixed.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        let diffValFormat = parts.join(".");

        if (diffValFormat) {
          return diffValFormat;
        }
      }
      return 0;
    },
    async generateShareTemplate() {
      this.isPrepareCompleted = false;
      // begin query data
      let detail = this.detail;
      let obj = {
        fund_id: this.id,
        period: "3M",
        type: "price"
      };
      let colorPlus = "#2FAE55";
      let colorMinus = "#da1616";
      let randomState = Math.floor(Math.random() * 10000000000);
      let data3M = await this.findFundNavForShare(obj);
      let perfValue3M = await this.calculatePerfValue(data3M);
      let perfValueText3M = `${
        perfValue3M >= 0 ? "+" + perfValue3M + "%" : perfValue3M + "%"
      }`;
      let perfPercent3M = await this.calculatePerfPercent(data3M);
      let perfPercentText3M = `(${
        perfPercent3M >= 0 ? "+" + perfPercent3M + "%" : perfPercent3M + "%"
      })`;
      let perfColor3M = `${perfPercent3M >= 0 ? colorPlus : colorMinus}`;
      let cardGraphImg = `${process.env.VUE_APP_IMAGE_SERVICE_URL}/graph/fund?name=${detail.short_code}&period=3M&state=${randomState}`;
      let card3DImg = `${process.env.VUE_APP_IMAGE_SERVICE_URL}/graph3d/fund?name=${detail.short_code}&state=${randomState}`;
      // end query data

      // begin prepare data
      let return3M = `${
        detail.total_return_3m != null
          ? this.numberToFixed(detail.total_return_3m) + "%"
          : "-"
      }`;
      let return6M = `${
        detail.total_return_6m != null
          ? this.numberToFixed(detail.total_return_6m) + "%"
          : "-"
      }`;
      let return1Y = `${
        detail.total_return_1y != null
          ? this.numberToFixed(detail.total_return_1y) + "%"
          : "-"
      }`;
      let return3Y = `${
        detail.total_return_3y != null
          ? this.numberToFixed(detail.total_return_3y) + "%"
          : "-"
      }`;
      let return5Y = `${
        detail.total_return_5y != null
          ? this.numberToFixed(detail.total_return_5y) + "%"
          : "-"
      }`;
      let return10Y = `${
        detail.total_return_10y != null
          ? this.numberToFixed(detail.total_return_10y) + "%"
          : "-"
      }`;
      let minimumFirstTrade = `${
        detail.minimum_initial != null
          ? this.comma(detail.minimum_initial)
          : "-"
      }`;
      let hasDividended = `${
        detail.dividend_policy != null ? detail.dividend_policy : "-"
      }`;
      let saleFees = `${this.netFee ? this.netFee : "ไม่มีข้อมูล"}`;
      let redemptionFees = `${
        this.backEndFee ? this.backEndFee : "ไม่มีข้อมูล"
      }`;
      let managementFees = `${
        this.managementFee ? this.managementFee : "ไม่มีข้อมูล"
      }`;
      let expenseAndFees = `${this.allFee ? this.allFee : "ไม่มีข้อมูล"}`;
      // end prepare data

      // begin replace data in flex card
      // flex 1
      let templateFex = JSON.stringify(QuoteTemplate);
      templateFex = templateFex.replace(
        "${card_name_send}",
        `ข้อมูลกองทุน ${detail.short_code}`
      );
      templateFex = templateFex.replace("${card_title}", detail.short_code);
      templateFex = templateFex.replace("${card_description}", detail.name_th);
      templateFex = templateFex.replace(
        "${card_value}",
        `${this.navLatest.value} ฿`
      );
      templateFex = templateFex.replace(
        "${card_perf_3m_value}",
        `${perfPercent3M} ${perfPercentText3M}`
      );
      templateFex = templateFex.replace(
        "${card_perf_3m_value_color}",
        perfColor3M
      );
      templateFex = templateFex.replace(
        "${card_date}",
        this.convertDate(this.navLatest.nav_date)
      );
      templateFex = templateFex.replace("${card_graph_img}", cardGraphImg);
      templateFex = templateFex.replace(
        "${card_redirect_url_graph}",
        `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&id=${detail.id}`
      );
      templateFex = templateFex.replace(
        "${card_redirect_url_body}",
        `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&id=${detail.id}`
      );
      templateFex = templateFex.replace(
        "${card_redirect_url_body}",
        `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&id=${detail.id}`
      );
      templateFex = templateFex.replace("${return_3m}", return3M);
      templateFex = templateFex.replace(
        "${return_3m_color}",
        `${detail.total_return_3m >= 0 ? colorPlus : colorMinus}`
      );
      templateFex = templateFex.replace("${return_6m}", return6M);
      templateFex = templateFex.replace(
        "${return_6m_color}",
        `${detail.total_return_6m >= 0 ? colorPlus : colorMinus}`
      );
      templateFex = templateFex.replace("${return_1y}", return1Y);
      templateFex = templateFex.replace(
        "${return_1y_color}",
        `${detail.total_return_1y >= 0 ? colorPlus : colorMinus}`
      );
      templateFex = templateFex.replace("${return_3y}", return3Y);
      templateFex = templateFex.replace(
        "${return_3y_color}",
        `${detail.total_return_3y >= 0 ? colorPlus : colorMinus}`
      );
      templateFex = templateFex.replace("${return_5y}", return5Y);
      templateFex = templateFex.replace(
        "${return_5y_color}",
        `${detail.total_return_5y >= 0 ? colorPlus : colorMinus}`
      );
      templateFex = templateFex.replace("${return_10y}", return10Y);
      templateFex = templateFex.replace(
        "${return_10y_color}",
        `${detail.total_return_10y >= 0 ? colorPlus : colorMinus}`
      );
      templateFex = templateFex.replace(
        "${minimum_first_trade}",
        minimumFirstTrade
      );
      templateFex = templateFex.replace("${has_dividended}", hasDividended);
      templateFex = templateFex.replace(
        "${card_cta_1}",
        `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&id=${detail.id}`
      );
      templateFex = templateFex.replace(
        "${card_cta_footer_1}",
        `${process.env.VUE_APP_LIFF_LINK}`
      );
      templateFex = templateFex.replace(
        "${card_footer_logo_1}",
        `${process.env.VUE_APP_SCONTENT_URL}/line-liff/flex/logo-footer.png`
      );
      templateFex = templateFex.replace(
        "${card_footer_link_icon_1}",
        `${process.env.VUE_APP_SCONTENT_URL}/line-liff/flex/footer-link-icon.png`
      );

      // flex 2
      templateFex = templateFex.replace("${card_title_2}", detail.short_code);
      templateFex = templateFex.replace(
        "${card_description_2}",
        detail.name_th
      );
      templateFex = templateFex.replace(
        "${card_value_2}",
        `${this.navLatest.value} ฿`
      );
      templateFex = templateFex.replace(
        "${card_perf_3m_value_2}",
        `${perfPercent3M} ${perfPercentText3M}`
      );
      templateFex = templateFex.replace(
        "${card_perf_3m_value_color_2}",
        perfColor3M
      );
      templateFex = templateFex.replace(
        "${card_date_2}",
        this.convertDate(this.navLatest.nav_date)
      );
      templateFex = templateFex.replace("${card_3d_img}", card3DImg);
      templateFex = templateFex.replace(
        "${card_redirect_url_3d}",
        `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&id=${detail.id}`
      );
      templateFex = templateFex.replace(
        "${card_redirect_url_body_2}",
        `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&id=${detail.id}`
      );
      templateFex = templateFex.replace("${sale_fees}", saleFees);
      templateFex = templateFex.replace("${redemption_fees}", redemptionFees);
      templateFex = templateFex.replace("${management_fees}", managementFees);
      templateFex = templateFex.replace("${expense_and_fees}", expenseAndFees);
      templateFex = templateFex.replace(
        "${card_cta_2}",
        `${process.env.VUE_APP_LIFF_LINK}?page=${this.$route.name}&id=${detail.id}`
      );
      templateFex = templateFex.replace(
        "${card_cta_footer_2}",
        `${process.env.VUE_APP_LIFF_LINK}`
      );
      templateFex = templateFex.replace(
        "${card_footer_logo_2}",
        `${process.env.VUE_APP_SCONTENT_URL}/line-liff/flex/logo-footer.png`
      );
      templateFex = templateFex.replace(
        "${card_footer_link_icon_2}",
        `${process.env.VUE_APP_SCONTENT_URL}/line-liff/flex/footer-link-icon.png`
      );
      this.templateShare = JSON.parse(templateFex);

      // end replace data in flex card

      this.isPrepareCompleted = true;
    },
    async queryData(id) {
      await new Promise(resolve => setTimeout(resolve, 3000))
      if (this.getIslogin) {      
        this.isFollowing = await this.checkAssetInWatchlist({
          subjectType: 'fund', 
          id: this.detail.id
        })
        let taskProcess = await this.mixins_get_task('task-after-login')
        if(taskProcess && taskProcess.action == 'watchlist'){
          if(taskProcess.criteria && taskProcess.criteria.id == this.detail.id){
            await this.mixins_delete_task('task-after-login')
            if (!this.isFollowing) {
              await this.watchListProcess()
            }
          }
        }
      }

      const rs_nav_latest = await this.findFundNavLatest(id);
      if (rs_nav_latest) {
        this.navLatest = rs_nav_latest;
      }

      const rs_3d = await this.findFund3D(id);
      if (rs_3d.data) {
        this.arrD3 = rs_3d.data;
      }

      const rs = await this.findFundDividend(id);
      if (rs && rs.length > 0) {
        this.arrDividend = rs;
      }

      let rs_fee = await this.findFundFee(id);
      if (rs_fee && rs_fee.fees && rs_fee.fees.length > 0) {
        let fees = rs_fee.fees;
        for (let i = 0; i < fees.length; i++) {
          if (fees[i].feetypedesc == "ค่าธรรมเนียมการจัดการ") {
            this.netFee = fees[i].actualvalue;
            if (this.isNumber(fees[i].actualvalue)) {
              this.netFee = `${Number(fees[i].actualvalue).toFixed(
                2
              )} %  ต่อปี`;
            }
          } else if (
            fees[i].feetypedesc ==
            "ค่าธรรมเนียมการรับซื้อคืนหน่วยลงทุน (Back-end Fee)"
          ) {
            this.backEndFee = fees[i].actualvalue;

            if (this.isNumber(fees[i].actualvalue)) {
              this.backEndFee = `${Number(fees[i].actualvalue).toFixed(2)} %`;
            }
          } else if (fees[i].feetypedesc == "ค่าธรรมเนียมการจัดการ") {
            this.managementFee = fees[i].actualvalue;

            if (this.isNumber(fees[i].actualvalue)) {
              this.managementFee = `${Number(fees[i].actualvalue).toFixed(
                2
              )} %`;
            }
          } else if (
            fees[i].feetypedesc == "ค่าธรรมเนียมและค่าใช้จ่ายรวมทั้งหมด"
          ) {
            this.allFee = fees[i].actualvalue;

            if (this.isNumber(fees[i].actualvalue)) {
              this.allFee = `${Number(fees[i].actualvalue).toFixed(2)} %`;
            }
          }
        }
      }

      const rs_tags = await this.findTagsByTagName(this.detail.short_code);
      if (rs_tags && rs_tags.length > 0) {
        const tag_id = rs_tags[0].id;
        let obj = {
          tags: tag_id,
          per_page: 5
        };
        const rs_article = await this.findArticleByParams(obj);
        if (rs_article && rs_article.length > 0) {
          this.arrArticle = rs_article;
        }
      }
    },
    open(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    },
    handleScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      this.$emit("current-scroll", currentScrollPosition);
    },
    async watchListProcess(){
      this.loadingWatchlist = !this.loadingWatchlist
      const action = this.isFollowing ? 'unfollow': 'follow'
      const data = {
        subject_id: this.detail.id
      }
      this.options.toast.title = action == 'follow' ? [{ success: "ติดตามสำเร็จ", unsuccess: "ติดตามไม่สำเร็จ" }] : [{ success: "เลิกติดตามสำเร็จ", unsuccess: "เลิกติดตามไม่สำเร็จ"}]
      const updateResult = await this.updateWatchlist({ 
        subjectType: 'fund', 
        action: action, 
        payload: data 
      })

      setTimeout(() => {
        this.loadingWatchlist = !this.loadingWatchlist;
        if (updateResult) {
          this.isFollowing = !this.isFollowing
        }
        this.toastType = "alert";
        this.toastStatus = updateResult == true
        this.toggleToast = true;
      }, 500);
    },
    async addWatchlist() {
      if (!this.getIslogin) {
        let obj = {
          action: "watchlist",
          criteria: {
            name: this.detail.short_code,
            id: this.detail.id
          }
        }
        await this.mixins_set_task('task-after-login', obj);
        this.redirectToAuth()
      }else{
        await this.watchListProcess()
      }      
    },
    urlAMC(id) {
      return (
        "https://www.thaimutualfund.com/AIMC/aimc_fundProfile2.jsp?id=" + id
      );
    },
    urlGoogle(shortcode) {
      return (
        "https://www.google.co.th/search?dcr=0&source=hp&q=" +
        shortcode +
        "+สรุปสาระสำคัญ&oq=" +
        shortcode +
        "+สรุปสาระสำคัญ"
      );
    },
    openFundFactSheet(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: true
        });
      } catch (err) {
        window.open(url);
      }
    },
    isNumber(value) {
      try {
        const rate = Number(value).toFixed(2);
        if (!isNaN(rate)) {
          return true;
        }
      } catch (err) {
        throw new Error(err);
      }

      return false;
    },
    parseNumberFormat(num) {
      if (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "0";
    },
    generateFeederFund(link, name) {
      var url = "";

      if (link && link.length > 0) {
        // eslint-disable-next-line no-useless-escape
        if (!/^(?:f|ht)tps?\:\/\//.test(link)) {
          url = "http://" + link;
        } else {
          url = link;
        }
      } else {
        url = this.urlGoogleFeederFund(name);
      }
      return url;
    },
    urlGoogleFeederFund(shortcode) {
      return "https://www.google.co.th/search?dcr=0&source=hp&q=" + shortcode;
    },
    viewPerfAll() {
      this.$router.push({
        name: "miniapp-fund-quote-performance",
        query: { id: this.id }
      });
      window.scrollTo(0, 0);
    },
    D3Class(d3Text) {
      if (d3Text == "best") {
        return { excellent: true };
      } else if (d3Text == "great") {
        return { great: true };
      } else if (d3Text == "good") {
        return { good: true };
      } else if (d3Text == "fair") {
        return { medium: true };
      } else {
        // code
      }
    },
    D3Text(d3Text) {
      if (d3Text == "best") {
        return "ดีที่สุด";
      } else if (d3Text == "great") {
        return "ดีมาก";
      } else if (d3Text == "good") {
        return "ดี";
      } else if (d3Text == "fair") {
        return "ปานกลาง";
      } else {
        return "-";
      }
    },
    callModal() {
      dataLayer.clickDividendHistory();
      this.isModal = true;
    },
    chartModal(short_code) {
      this.$router.push({
        name: "miniapp-tradingview",
        query: { name: short_code, type: "fund" }
      });
    },
    closeModal(bool) {
      if (bool) {
        this.isModal = false;
      }
    },
    changeFormatDate(date) {
      if (date && date !== "1900-01-01") {
        let today = new Date(date);
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        return dd + "/" + mm + "/" + yyyy;
      }
      return "-";
    },
    closeToast(bool) {
      this.toggleToast = bool;
    },
    async sendFundInvestNow() {
      this.$liff.ready.then(async () => {
        await this.$liff
          .getProfile()
          .then(async profile => {
            const imgName = "Broadcast-Line-Mini-App"
            const redirectUrl = "https://link.finnomena.com/invest-now"

            let obj = {
              line_id: profile.userId,
              img_name: imgName,
              redirect_url: redirectUrl
            };

            await this.sendFundInvestImage(obj)
            .then(() => {
              this.open(process.env.VUE_APP_OA_URL_NEW_SCHEME)
            })
            .catch(error => {
                console.error("Error push line message: " + error);
            })
          })
          .catch(error => {
            console.error("Error getting profile: " + error);
          });
      })
    },
    async investNow() {
      this.isSending = true;
      this.isLoading = true;

      const accessToken = this.$liff.getAccessToken();
      let obj = {
        access_token: accessToken
      };
      const rs = await this.findFriendship(obj);

      if (rs.success && rs.data) {
        if (rs.data.friendFlag) {
          await this.sendFundInvestNow()
          this.isLoading = false;
          setTimeout(() => {
            this.isSending = false;
          }, 1000);
          return;
        } else {
          this.isLoading = false;
          this.isSending = false;
          this.noFriendship = true;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$radius-size: 8px;
#article-fund-overview {
  #section-fund-intro {
    @extend %container-style;
    margin-top: 24px;
    .intro-header {
      .intro-header-name {
        @include finCol(7, 12, 0px, top, true, true);
        h1 {
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          @extend %font-size-l;
          color: $color-normal-text;
        }
        p {
          margin: 0;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          @extend %font-size-ss;
          color: $color-secondary-text;
        }
      }
      .intro-subscriber {
        @include finCol(5, 12, 0px, middle, true, true);
        text-align: right;
        user-select: none;
        .subscribe-btn {
          margin-left: 15px;
          color: $color-light-grey-2;
          vertical-align: middle;
          i {
            color: $color-light-grey-2;
            font-size: 22px;
            vertical-align: top;
          }
        }
        .share-assets {
          margin-right: 15px;
          vertical-align: middle;
          pointer-events: auto;
          cursor: pointer;
          i {
            pointer-events: none;
            color: $color-light-grey-2;
            font-size: 22px;
          }
        }
        .download-assets {
          margin: 0 15px;
          vertical-align: middle;
          i {
            font-size: 22px;
            vertical-align: top;
          }
        }
        .following {
          color: $color-primary-finno !important;
          vertical-align: middle;
          i {
            font-size: 22px;
          }
        }
      }
    }
    .intro-nav {
      .fund-nav {
        @extend %font-size-xxl;
        display: inline-block;
      }
      span {
        @extend %font-size-l;
        margin-left: 5px;
        display: inline-block;
        font-weight: bold;
      }
      .date-nav {
        margin: 0;
        @extend %font-size-s;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: $color-secondary-text;
      }
    }
  }
  #section-graph {
    margin: 24px auto;
    @extend %container-style;
    padding-left: 0;
    padding-right: 0;
    .graph-ctn {
      @include finCol(12, 12, 0px, middle, true, true);
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: flex;
    }
  }
  #section-invest-now {
    justify-content: center;
    display: flex;
    .invest-now {
      &__container {
        color: #f7a501;
        display: flex;
        border: 1px solid #ffcd00;
        padding: 10px 100px;
        border-radius: .5rem;
        cursor: pointer;
        background: white;
        &--text {
          font-weight: bold;
        }
        &--icon {
          margin-top: 5px;
          margin-right: 10px;
        }
      }
    }
  }
  #section-perf-overview {
    @extend %container-style;
    margin: 32px auto;
    h2 {
      color: $color-normal-text;
      @extend %font-size-m;
      margin-bottom: 5px;
    }
    .perf-box {
      border-radius: 8px;
      border: solid 1px $color-border;
      display: flex;
      padding: 11px 0;

      .perf-item {
        text-align: center;
        width: 25%;
        p {
          margin: 0;
          color: $color-secondary-text;
          @extend %font-size-s;
        }
        &:not(:first-child) {
          border-left: 1px solid $color-border;
        }
      }
      .view-all-perf {
        display: flex;
        align-items: center;
        justify-content: center;
        a {
          text-decoration: none;
          color: $color-normal-text;
          font-weight: bold;
          @extend %font-size-ss;
          text-align: center;
          vertical-align: middle;
          i {
            margin-left: 8px;
            font-size: 12px;
            vertical-align: middle;
          }
        }
      }
    }
  }
  #section-dividend {
    @extend %container-style;
    margin: 32px auto;
    h2 {
      @extend %font-size-m;
      margin-bottom: 5px;
      color: $color-normal-text;
    }
    .dividend-box {
      border-radius: 8px;
      border: solid 1px $color-border;
      display: flex;
      padding: 11px;
      .dividend-detail {
        @include finCol(8, 12, 0px, middle, true, true);
        text-align: center;
        position: relative;

        .detail-row {
          .detail-col {
            @include finCol(6, 12, 0px, middle, true, true);
            h4 {
              color: $color-normal-text;
              @extend %font-size-s;
              font-weight: bold;
              margin-bottom: 10px;
              display: inline-block;
            }
            p {
              margin: 0;
              margin-top: 10px;
              @extend %font-size-s;
              margin-top: 10px;
            }
          }
        }
        .line-seperate {
          position: absolute;
          width: 100%;
          height: 1px;
          background-color: $color-border;
          top: 50%;
        }
      }
      .dividend-ctn {
        @include finCol(4, 12, 0px, middle, true, true);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        a {
          text-decoration: none;
          color: $color-normal-text;
          font-weight: bold;
          @extend %font-size-ss;
          i {
            margin-left: 8px;
          }
        }
      }
    }
  }
  #section-3d-diagram {
    @extend %container-style;
    margin: 32px auto;
    h2 {
      @extend %font-size-m;
      color: $color-normal-text;
    }
    .d3-radar {
      position: relative;
      display: table;
      margin-top: 20px;
      width: 100%;
      margin-left: auto;
      margin-right: auto;

      .d3-radar-left {
        display: table-cell;
        width: 20%;
        text-align: right;
        vertical-align: top;
        padding-top: 35px;
        @include multipleResponsive(phablet, tablet) {
          width: 30%;
        }
      }
      .d3-radar-center {
        display: table-cell;
        width: 60%;
        text-align: center;
        vertical-align: top;
        @include multipleResponsive(phablet, tablet) {
          width: 40%;
        }
        .d3-diagram {
          -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
          height: 180px;
        }
        .line-dashed {
          border-bottom: 2.2px dashed#a2a2a2;
          width: 120px;
          margin: 0 auto;
        }
      }
      .d3-radar-right {
        display: table-cell;
        width: 20%;
        text-align: left;
        vertical-align: top;
        padding-top: 35px;
        @include multipleResponsive(phablet, tablet) {
          width: 30%;
        }
      }
      p {
        font-size: 10px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        color: #727272;
        margin: 0;
      }
    }
  }
  #section-fund-detail {
    @extend %container-style;
    margin: 32px auto;
    h2 {
      @extend %font-size-m;
    }
    .fund-detail {
      .detail-list {
        padding: 8px 0;
        &:not(:last-child) {
          border-bottom: 1px solid $color-border;
        }
        .col-head {
          @include finCol(5, 12, 0px, middle, true, true);
          @extend %font-size-ss;
          color: $color-secondary-text;
        }
        .col-value {
          @include finCol(7, 12, 0px, middle, true, true);
          @extend %font-size-ss;
          color: $color-normal-text;
          .fund-fact-sheet {
            @include finRippleBtn(#f9f9f9, #f9f9f9, $color-normal-text);
            text-decoration: none;
            padding: 3px 13px;
            font-weight: bold;
          }
          .feeder-fund {
            color: $color-normal-text;
          }
        }
      }
    }
  }
  #section-related-article {
    @extend %container-style;
    margin: 32px auto;
    h2 {
      @extend %font-size-m;
    }

    .post-card {
      margin: 16px 0;
      background-color: $color-white;
      border-radius: $radius-size;
      -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
      -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
      pointer-events: auto;
      .article-link {
        text-decoration: none;
        pointer-events: none;
      }
      .image {
        pointer-events: none;
        @include multipleResponsive(phablet, tablet) {
          @include finCol(6, 12, 16px, middle, true, true);
        }
        .thumbnail {
          border-top-left-radius: $radius-size;
          border-top-right-radius: $radius-size;
          display: block;
          width: 100%;
          object-fit: cover;
          @include multipleResponsive(phablet, tablet) {
            border-top-right-radius: 0;
            border-bottom-left-radius: $radius-size;
          }
        }
      }
      .content {
        pointer-events: none;
        @include multipleResponsive(phablet, tablet) {
          @include finCol(6, 12, 16px, middle, true, true);
          padding: 0 16px;
          vertical-align: text-bottom;
          text-decoration: none;
        }
        .description {
          @extend %font-size-ss;
          font-weight: bold;
          color: $color-normal-text;
          padding: 16px 16px;
          margin: 0px;
          display: flex;
          .block-ellipsis {
            display: inline-block;
            display: -webkit-box;
            margin: 0; // 0 auto
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }
  #fund-dividend {
    // @extend %container-style;
    h2 {
      @extend %font-size-m;
      margin-bottom: 16px;
    }
    .dividend-table {
      .dividend-head {
        .dividend-row {
          background-color: $color-white !important;
        }
        .dividend-col {
          @extend %font-size-ss;
          font-weight: bold;
          color: $color-normal-text;
          height: 40px;
        }
      }
      .dividend-body {
        .dividend-col {
          @extend %font-size-ss;
          font-weight: normal;
          color: $color-normal-text;
          height: 32px;
        }
      }
      .dividend-row {
        display: table;
        width: 100%;
        &:nth-child(odd) {
          background-color: #f9f9f9;
        }
        .dividend-col {
          width: 33.33%;
          display: table-cell;
          text-align: center;
          vertical-align: middle;
        }
      }
    }
  }
}
.value-pill {
  display: inline-block;
  visibility: hidden;
  color: $base-white;
  border-radius: 16.6px;
  @extend %font-size-sss;
  color: #ffffff;
  width: 55px;
  padding: 0;
  text-align: center;
  margin: 0 auto;
  text-decoration: none;
}
.excellent {
  visibility: visible;
  background-color: #108a48;
  color: $color-white;
}
.good {
  visibility: visible;
  background-color: #85d5aa;
  color: $color-white;
}
.great {
  visibility: visible;
  background-color: #25c970;
  color: $color-white;
}

.medium {
  visibility: visible;
  color: #7f7f7f;
}
</style>